export default __webpack_public_path__ + "static/media/iconShare.c167983b.svg";